/**
 * Component will contain all dialogs that could be displayed. Currently it is dialog for Adding Page only.
 */
import React from "react";
import { connect } from "react-redux";
import AddSecUserDialog from "./AddSecUserDialog";
import RemoveSecUserDialog from "./RemoveSecUserDialog";
import AddSecProfileDialog from "./AddSecProfileDialog";
import EditSecProfileDialog from "./EditSecProfileDialog";
import AddSecRoleDialog from "./AddSecRoleDialog";
import EditSecRoleDialog from "./EditSecRoleDialog";
function Dialogs(props) {
  const { isAuthenticated, dialogs } = props;
  const {
    addSecUser,
    removeSecUser,
    addSecRole,
    addSecProfile,
    editSecRole,
    editSecProfile,
  } = dialogs;

  return (
    <>
      {isAuthenticated && (
        <>
          {addSecUser !== null && <AddSecUserDialog data={addSecUser} />}
          {removeSecUser !== null && (
            <RemoveSecUserDialog data={removeSecUser} />
          )}
          {editSecRole !== null && <EditSecRoleDialog groupId={editSecRole} />}
          {addSecRole !== null && <AddSecRoleDialog data={addSecRole} />}
          {addSecProfile !== null && (
            <AddSecProfileDialog data={addSecProfile} />
          )}
          {editSecProfile !== null && (
            <EditSecProfileDialog profileId={editSecProfile} />
          )}
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.user.isAuthenticated,
    dialogs: state.dialogs,
  };
};

export default connect(mapStateToProps)(Dialogs);
